import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ErrorPanel(props) {
    var _a;
    return (_jsxs("div", { children: [(_a = props.title) !== null && _a !== void 0 ? _a : 'Error', props.children && (_jsxs(_Fragment, { children: [_jsx("hr", {}), _jsx("pre", { children: props.children }), ' '] }))] }));
}
